import { render, staticRenderFns } from "./AppFooterMenuItem.vue?vue&type=template&id=c73130f4&scoped=true&"
import script from "./AppFooterMenuItem.vue?vue&type=script&lang=ts&"
export * from "./AppFooterMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppFooterMenuItem.vue?vue&type=style&index=0&id=c73130f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73130f4",
  null
  
)

export default component.exports